import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col px-6 py-6 overflow-x-hidden md:min-h-13rem lg:overflow-x-visible card card-border card-hoverable hover-shadow-elevation hover:border-transparent relative" }
const _hoisted_2 = { class: "text-darkText course-header bg-light bg-opacity-0 flex items-start py-4 -mt-4 rounded-t" }
const _hoisted_3 = { class: "flex items-start space-x-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  style: {"min-height":"2.8rem","min-width":"2.8rem","max-height":"2.8rem","max-width":"2.8rem"},
  class: "w-8 h-8 flex mb-full rounded-full bg-primary bg-opacity-15"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"font-size":"2.05rem"},
    class: "m-auto text-primary material-icons-outlined icon-light"
  }, " book ")
], -1)
const _hoisted_5 = { class: "mb-auto mt-0.5" }
const _hoisted_6 = {
  style: {"line-height":"25px","font-size":"20px"},
  class: "hidden lg:block mb-1.5 pr-4.5 font-normal"
}
const _hoisted_7 = {
  style: {"line-height":"22px"},
  class: "lg:hidden mb-1.5 pr-4.5 font-normal"
}
const _hoisted_8 = {
  style: {"font-weight":"400"},
  class: "-mb-0.5 text-xs text-muted uppercase"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mr-4 text-lg opacity-50 inline-icon icon-light material-icons-outlined" }, " visibility_off ", -1)
const _hoisted_10 = { class: "my-1" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "mt-auto flex w-full" }
const _hoisted_13 = { class: "flex flex-col mt-auto space-y-1.5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-2" }, "person_add", -1)
const _hoisted_15 = { class: "text-base 2xl:text-lg" }
const _hoisted_16 = { class: "text-base 2xl:text-lg" }
const _hoisted_17 = { class: "ml-auto flex items-center mt-auto" }
const _hoisted_18 = { class: "material-icons" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "person_remove", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.course.name), 1),
            _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.course.name), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.course.creator?.full_name), 1)
          ])
        ])
      ]),
      (_ctx.course.hidden)
        ? (_openBlock(), _createBlock(_component_Tooltip, {
            key: 0,
            textCode: 'hidden_course',
            placement: 'bottom',
            noArrow: true,
            class: "mt-1 ml-1"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.formattedDescription)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            style: {"line-height":"1.2rem","font-weight":"400","opacity":"0.8"},
            class: "my-3 text-sm",
            title: _ctx.course.description
          }, _toDisplayString(_ctx.formattedDescription), 9, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (!_ctx.canAccessCoursePanel && !_ctx.course.enrolled)
          ? (_openBlock(), _createBlock(_component_Btn, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('enroll'))),
              size: 'sm',
              variant: 'primary',
              outline: true
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("enrollment.enroll")), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "w-full",
              to: {
						name: 'StudentCourseDashboard',
						params: { courseId: _ctx.course.id },
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Btn, {
                  size: 'xs',
                  variant: 'primary-borderless',
                  outline: true,
                  class: "whitespace-nowrap font-medium"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.metaStore.user.is_teacher || _ctx.canAccessCoursePanel
								? _ctx.$t("courses.access_as_student")
								: _ctx.$t("courses.go_to_course")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])),
        (_ctx.canAccessCoursePanel)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              class: "",
              to: {
						name: 'TeacherCourseDashboard',
						params: { courseId: _ctx.course.id },
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Btn, {
                  size: 'xs',
                  outline: true,
                  variant: 'primary-borderless',
                  class: "font-medium"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("courses.course_panel")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_Btn, {
          variant: 'icon',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleFavorite'))),
          outline: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.course.bookmarked ? "bookmark" : "bookmark_outline"), 1)
          ]),
          _: 1
        }),
        (_ctx.course.enrolled)
          ? (_openBlock(), _createBlock(_component_Btn, {
              key: 0,
              variant: 'icon',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('unenroll'))),
              outline: true,
              tooltip: _ctx.$t('enrollment.unenroll')
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["tooltip"]))
          : _createCommentVNode("", true),
        _createVNode(_component_CopyToClipboard, {
          iconOnly: true,
          tooltip: _ctx.$t('misc.share'),
          confirmationMessage: _ctx.$t('event_preview.copied_link'),
          value: _ctx.permalink
        }, null, 8, ["tooltip", "confirmationMessage", "value"])
      ])
    ])
  ]))
}